import {
  SET_USER_INFO,
  SET_BOOKING_HISTORY,
  SET_USER_BALANCE,
  SET_CURRENT_USER_BALANCE,
  DECREMENT_COIN
} from '@/store/mutations.js';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  state: {
    info: {},
    bookingHistory: []
  },

  mutations: {
    [SET_USER_INFO]: (state, payload) => {
      state.info = payload;
    },

    [SET_BOOKING_HISTORY]: (state, history) => {
      state.bookingHistory = [...state.bookingHistory, ...history];
    },

    // TODO переделать
    [SET_USER_BALANCE]: (state, { amount }) => {
      state.info.balance = (Number(state.info.balance) + amount).toFixed(2);
    },

    [SET_CURRENT_USER_BALANCE]: (state, { amount }) => {
      state.info.balance = amount.toFixed(2);
    },

    [DECREMENT_COIN]: (state, { coin }) => {
      state.info.coin = coin;
    }
  },

  actions: {
    async getUserInfo({ commit }) {
      const res = await apiRequest('user', 'GET', null, true);

      if (res.error) {
        notify({ text: res.error });
        throw { customeError: res.error };
      }

      const {
        id,
        name,
        last_name: lastName,
        email,
        balance,
        gold,
        ref_code: refCode,
        star_coef: starCoef,
        bot_url,
        bot_text,
        status,
        booking,
        timezone,
        share_history
      } = res.success;

      commit(SET_USER_INFO, {
        id,
        name,
        lastName,
        email,
        balance: balance.toFixed(2),
        coin: gold,
        refCode,
        starCoef,
        bot_url,
        bot_text,
        status,
        timezone,
        shareHistory: !!share_history
      });

      commit(
        SET_BOOKING_HISTORY,
        booking.map(({ id, start, level_id, language_id }) => ({
          id,
          start,
          levelId: level_id,
          languageId: language_id
        }))
      );
    }
  }
};
